import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"

import Select from "react-select"

import ReactHTMLTableToExcel from "react-html-table-to-excel"
import Tooltip from "@material-ui/core/Tooltip"

const styles = (theme) => ({
   paperrtl: {
      marginTop: theme.spacing(0),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
   },
   paper: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
         margin: theme.spacing(1),
         width: theme.spacing(20),
      },
   },
   root: {
      width: "100%",
      margin: "15px",
      padding: "8px",
      direction: "rtl",
   },
   container: {
      maxHeight: 400,
   },
   large: {
      width: theme.spacing(10),
      height: theme.spacing(10),
   },
   small: {
      width: theme.spacing(6),
      height: theme.spacing(6),
   },
})

const Shorttext = (text) => {
   if (text.length < 10) {
      return text
   } else {
      return "..." + text.substr(0, 20)
   }
}


const optionInstalmentDate = [
   { value: "1", label: "تولید سند به صورت روزانه" },
   { value: "2", label: "تولید سند به صورت هفتگی" },
   { value: "3", label: "تولید سند به صورت روزانه" },
]

class ChangeReportDocCreate extends Component {
   cookies = new Cookies()
   temp333
   constructor(props) {
      super(props)
      this.state = {
         redirect: false,
         errstr: "",
         errstatus: false,
         okstatus: false,
         requestinfos: [],
         requestinfofilter: [],
         rowsPerPage: 10,
         page: 0,
         WalletUserMaxDate: "",
         WalletUserMinDate: "",
         selectedInstalmentDate: "",

         RefundUser: null,
         orderBy: "ID",
         order: "desc",
         snackstr: "",
         showSnack: false,
         snackMode: "success",
         strDesc:'سند تولید شده در تاریخ '
      }
   }

   componentDidMount() {
      if (this.cookies.get("employee_token_str")) {
         this.props.props.props.dispatch({
            type: "WAITSHOW",
         })

         var self = this
         var xhttp = new XMLHttpRequest()
         xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
               var arr = JSON.parse(this.responseText)
               if (arr.result === "ok") {
                  self.getFinancialDocPaing()
               } else if (arr.result === "error") {
                  self.setState({ redirect: true })
               }
               self.props.props.props.dispatch({
                  type: "WITEHIDE",
               })
            }
         }
         var fd = new FormData()
         fd.append("command", "checkemployeelogin")

         xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
         xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
         xhttp.send(fd)
      } else {
         this.setState({ redirect: true })
      }
   }

   getFinancialDocPaing() {
      const { rowsPerPage, page } = this.state

      this.props.props.props.dispatch({
         type: "WAITSHOW",
      })
      var self = this
      var xhttp = new XMLHttpRequest()
      xhttp.onreadystatechange = function () {
         if (this.readyState === 4 && this.status === 200) {
            var arr = JSON.parse(this.responseText)
            console.log(arr)
            if (arr.result === "ok") {
               self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {})
            } else if (arr.result === "error") {
            }
            self.props.props.props.dispatch({
               type: "WITEHIDE",
            })
         }
      }
      var fd = new FormData()
      fd.append("command", "send_doc_nosend")
      fd.append("limit", rowsPerPage)
      fd.append("offset", page * rowsPerPage)

      xhttp.open("POST", `${constants.BASE_URL}/creatdoc`)
      xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
      xhttp.send(fd)
   }



   creatDocPriod(command,dateStart) {
      const {  WalletUserMaxDate } = this.state
      var  timeStampEnd= parseInt(Moment(JDate.toGregorian(WalletUserMaxDate.year, WalletUserMaxDate.month, WalletUserMaxDate.day)).format("x"),0 )

      this.props.props.props.dispatch({
         type: "WAITSHOW",
      })

      console.log(timeStampEnd,command)

      var self = this
      var xhttp = new XMLHttpRequest()
      xhttp.onreadystatechange = function () {
         if (this.readyState === 4 && this.status === 200) {
            var arr = JSON.parse(this.responseText)
            console.log(arr)
            if (arr.result === "ok") {
               if(command==='create_paydoc_date'){
                  self.creatDocPriod('create_doc_request_date',dateStart);
                  self.setState({ strDesc: 'در حال تولید سند  درخواست های تاریخ '+ new JDate(
                         new Date(dateStart)
                     ).format("YYYY/MM/DD ")})
               }
               else if(command==='create_doc_request_date'){
                  self.creatDocPriod('create_comission_doc_date',dateStart);
                  self.setState({ strDesc: 'در حال تولید سند  کمیسیون های تاریخ '+ new JDate(
                         new Date(dateStart)
                     ).format("YYYY/MM/DD ")})
               }else if(command==='create_comission_doc_date'){
                  self.creatDocPriod('create_doc_clearing_date',dateStart);
                  self.setState({ strDesc: 'در حال تولید سند تسویه یا شرکت های بیمه تاریخ '+ new JDate(
                         new Date(dateStart)
                     ).format("YYYY/MM/DD ")})
               }else if(command==='create_doc_clearing_date'){
                  self.creatDocPriod('create_doc_installment_date',dateStart);
                  self.setState({ strDesc: 'در حال تولید سند پاس شدن تعهد های تاریخ '+ new JDate(
                         new Date(dateStart)
                     ).format("YYYY/MM/DD ")})
               }else if(command==='create_doc_installment_date'){
                  self.creatDocPriod('create_doc_refund_user_date',dateStart);
                  self.setState({ strDesc: 'در حال تولید سند بازگشت وجه های تاریخ '+ new JDate(
                         new Date(dateStart)
                     ).format("YYYY/MM/DD ")})
               }else
               if (command==='create_doc_refund_user_date'&&dateStart<timeStampEnd)
               {
                  console.log(dateStart,new JDate(
                      new Date(dateStart)
                  ).format("YYYY/MM/DD "),new JDate(
                      new Date(dateStart+86400000)
                  ).format("YYYY/MM/DD "))
                  var dateStart1=dateStart+86400000;
                  self. creatDocPriod('create_paydoc_date',dateStart1);
                  self.setState({ strDesc: 'در حال تولید سند پیش پرداختی های تاریخ '+ new JDate(
                         new Date(dateStart)
                     ).format("YYYY/MM/DD ")})
               }else if(dateStart>=timeStampEnd){
                  self.getFinancialDocPaing()
               }
            } else if (arr.result === "error") {
            }
            self.props.props.props.dispatch({
               type: "WITEHIDE",
            })
         }
      }
      var fd = new FormData()
      fd.append("command", command)
      fd.append(
          "min_date",
          Moment(
              new Date(dateStart)
          ).format("YYYY-MM-DD H:mm:ss")
      )
      fd.append(
          "max_date",
          Moment(
              new Date(dateStart+86400000)

          ).format("YYYY-MM-DD H:mm:ss")
      )
      xhttp.open("POST", `${constants.BASE_URL}/creatdoc`)
      xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
      xhttp.send(fd)

   }

   creatDoc(command) {

      this.props.props.props.dispatch({
         type: "WAITSHOW",
      })



      var self = this
      var xhttp = new XMLHttpRequest()
      xhttp.onreadystatechange = function () {
         if (this.readyState === 4 && this.status === 200) {
            var arr = JSON.parse(this.responseText)
            console.log(arr)
            if (arr.result === "ok") {
               self.getFinancialDocPaing()
            } else if (arr.result === "error") {
            }
            self.props.props.props.dispatch({
               type: "WITEHIDE",
            })
         }
      }
      var fd = new FormData()
      fd.append("command", command)

      xhttp.open("POST", `${constants.BASE_URL}/creatdoc`)
      xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
      xhttp.send(fd)

   }

   createSortHandler = (field) => {
      if (this.state.orderBy === field) {
         if (this.state.order === "asc") {
            this.setState({ order: "desc" })
         } else {
            this.setState({ order: "asc" })
         }
      } else {
         this.setState({ orderBy: field, order: "asc" })
      }
      var arraytemp = [],
         i,
         j,
         temp,
         a,
         b
      arraytemp = this.state.requestinfofilter
      for (i = 0; i < arraytemp.length; i++) {
         for (j = 0; j < arraytemp.length - 1; j++) {
            a = arraytemp[j]
            b = arraytemp[j + 1]
            if (a[field] < b[field] && this.state.order === "asc") {
               temp = arraytemp[j]
               arraytemp[j] = arraytemp[j + 1]
               arraytemp[j + 1] = temp
            } else if (a[field] > b[field] && this.state.order === "desc") {
               temp = arraytemp[j]
               arraytemp[j] = arraytemp[j + 1]
               arraytemp[j + 1] = temp
            }
         }
      }
   }

   setSelectedDayMax = (event) => {
      this.setState({ WalletUserMaxDate: event }, () => {
      })
   }

   clearDeyMax = (event) => {
      this.setState({ WalletUserMaxDate: "" }, () => {
      })
   }

   setSelectedDayMin = (event) => {
      this.setState({ WalletUserMinDate: event }, () => {
      })
   }

   clearDeyMin = (event) => {
      this.setState({ WalletUserMinDate: "" }, () => {
      })
   }


   handleChangeRowsPerPage = (event) => {
      this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
         this.getFinancialDocPaing()
      })
   }

   handleChangePage = (event, number) => {
      this.setState({ page: parseInt(number, 0) }, () => {
         this.getFinancialDocPaing()
      })
   }

   handleInstalmentDate = (selectedInstalmentDate) => {
      this.setState({ selectedInstalmentDate: selectedInstalmentDate })
   }

   renderCustomInputMax = ({ ref }) => (
       <OutlinedInput
           readOnly
           ref={ref} // necessary
           placeholder="تاریخ تولید سند از"
           style={{
              fontSize: "13px",
              direction: "ltr",
           }}
           value={
              this.state.WalletUserMaxDate.year
                  ? this.state.WalletUserMaxDate.year + "/" + this.state.WalletUserMaxDate.month + "/" + this.state.WalletUserMaxDate.day
                  : ""
           }
           className="my-custom-input-class" // a styling class
           endAdornment={
              <InputAdornment position="end">
                 <IconButton onClick={this.clearDeyMax}>
                    <HighlightOffIcon />
                 </IconButton>
              </InputAdornment>
           }
       />
   )

   renderCustomInputMin = ({ ref }) => (
       <OutlinedInput
           readOnly
           ref={ref} // necessary
           placeholder="تاریخ تولید سند تا"
           style={{
              fontSize: "13px",
              direction: "ltr",
           }}
           value={
              this.state.WalletUserMinDate.year
                  ? this.state.WalletUserMinDate.year + "/" + this.state.WalletUserMinDate.month + "/" + this.state.WalletUserMinDate.day
                  : ""
           }
           className="my-custom-input-class" // a styling class
           endAdornment={
              <InputAdornment position="end">
                 <IconButton onClick={this.clearDeyMin}>
                    <HighlightOffIcon />
                 </IconButton>
              </InputAdornment>
           }
       />
   )

   render() {
      const { classes } = this.props
      const { snackMode, WalletUserMaxDate,strDesc,
         WalletUserMinDate,selectedInstalmentDate, snackstr, showSnack, order, orderBy, okstatus, errstr, redirect, requestinfofilter, rowsPerPage, page, arrCount } =
         this.state
      if (redirect) {
         return <Redirect to="/" />
      } else {
         return (
            <div className={classes.paperrtl} dir="ltr">
               <Snackbar
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  onClose={this.handleClickcloseTasckBar}
                  open={showSnack}
                  autoHideDuration={10000}>
                  <Alert severity={snackMode}>{snackstr}</Alert>
               </Snackbar>
               <Grid container spacing={3}>
                  <Grid item xs={12}>
                     <Container component="main" maxWidth="lg">
                        <Paper elevation={4} className={classes.root}>
                           <Grid container spacing={3}>


                              <Grid item xs={3}>
                                 <div style={{ width: "100%", textAlign: "center" }}>
                                    <Typography variant="h7">
                                       {"تاریخ تولید سند از"}
                                       <Calendar
                                           renderInput={this.renderCustomInputMin} // render a custom input
                                           value={WalletUserMinDate}
                                           onChange={this.setSelectedDayMin}
                                           locale="fa"
                                           shouldHighlightWeekends
                                       />
                                    </Typography>
                                 </div>
                              </Grid>
                              <Grid item xs={3}>
                                 <div style={{ width: "100%", textAlign: "center" }}>
                                    <Typography variant="h7">
                                       {"تاریخ تولید سند تا"}
                                       <Calendar
                                           renderInput={this.renderCustomInputMax} // render a custom input
                                           value={WalletUserMaxDate}
                                           onChange={this.setSelectedDayMax}
                                           locale="fa"
                                           shouldHighlightWeekends
                                       />
                                    </Typography>
                                 </div>
                              </Grid>
                              <Grid item xs={3}>
                                 <div>
                                    <label className="on"> زمان</label>
                                    <Select
                                        isSearchable={true}
                                        className="adapter-txtsize"
                                        placeholder={"زمان"}
                                        value={selectedInstalmentDate}
                                        onChange={this.handleInstalmentDate}
                                        options={optionInstalmentDate}
                                    />
                                 </div>
                              </Grid>
                              <Grid item xs={3}>
                                 <Button
                                     variant="outlined"
                                     color="primary"
                                     onClick={(e) => {
                                        const { WalletUserMinDate } = this.state

                                        var  timeStampStart = parseInt(Moment(JDate.toGregorian(WalletUserMinDate.year, WalletUserMinDate.month, WalletUserMinDate.day)).format("x"), 0)

                                        this.creatDocPriod('create_paydoc_date',timeStampStart)
                                     }}>
                                    {"  تولید اسناد با زمان بندی "}
                                 </Button>
                              </Grid>
                              <Grid item xs={12}>
                                 {strDesc}
                              </Grid>

                              <Grid item xs={12}>
                                 <hr/>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={(e) => {
                                       this.creatDoc("create_paydoc")
                                    }}>
                                    {"    تولید اسناد پیش دریافتی "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={(e) => {
                                       this.creatDoc("create_doc_request")
                                    }}>
                                    {" تولید اسناد درخواست های صادر شده و تایید شده "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={(e) => {
                                       this.creatDoc("create_comission_doc")
                                    }}>
                                    {" تولید اسناد کمیسوین ها "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={(e) => {
                                       this.creatDoc("create_doc_clearing")
                                    }}>
                                    {"   تولید اسناد تسویه بیمه نامه "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={(e) => {
                                       this.creatDoc("create_doc_installment")
                                    }}>
                                    {"   تولید اسناد  تعهدات پاس شده "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={(e) => {
                                       this.creatDoc("create_doc_refund_user")
                                    }}>
                                    {"   تولید اسناد درخواست های بازگشت وجه "}
                                 </Button>
                              </Grid>

                              <Grid item xs={4}>
                                 <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={(e) => {
                                       this.uploadPicDelivery("new")
                                    }}>
                                    {"  ارسال به سرور مالی "}
                                 </Button>
                              </Grid>
                              <Grid item xs={8}>
                              </Grid>

                              <Grid item xs={12}>
                                 <hr/>
                              </Grid>

                              <Grid item xs={4}>
                                 <Button
                                     variant="outlined"
                                     color="primary"
                                     onClick={(e) => {
                                        this.creatDoc("delete_paydoc")
                                     }}>
                                    {"  حذف اسناد پیش دریافتی "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                     variant="outlined"
                                     color="primary"
                                     onClick={(e) => {
                                        this.creatDoc("delete_doc_request")
                                     }}>
                                    {" حذف اسناد درخواست های صادر شده و تایید شده "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                     variant="outlined"
                                     color="primary"
                                     onClick={(e) => {
                                        this.creatDoc("delete_comission_doc")
                                     }}>
                                    {" حذف اسناد کمیسوین ها "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                     variant="outlined"
                                     color="primary"
                                     onClick={(e) => {
                                        this.creatDoc("delete_doc_clearing")
                                     }}>
                                    {"   حذف اسناد تسویه بیمه نامه "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                     variant="outlined"
                                     color="primary"
                                     onClick={(e) => {
                                        this.creatDoc("delete_doc_installment")
                                     }}>
                                    {"   حذف اسناد  تعهدات پاس شده "}
                                 </Button>
                              </Grid>
                              <Grid item xs={4}>
                                 <Button
                                     variant="outlined"
                                     color="primary"
                                     onClick={(e) => {
                                        this.creatDoc("delete_doc_refund_user")
                                     }}>
                                    {"   حذف اسناد درخواست های بازگشت وجه "}
                                 </Button>
                              </Grid>





                           </Grid>
                        </Paper>
                     </Container>
                  </Grid>

                  <Grid item xs={12}>
                     <Container maxWidth="lg">
                        <Paper className={classes.root}>
                           <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className="download-table-xls-button"
                              table="table-to-xls"
                              filename="tablexls"
                              sheet="tablexls"
                              buttonText="Download as XLS"
                           />

                           <TableContainer dir="rtl">
                              <Table id="table-to-xls" aria-label="sticky table">
                                 <TableHead>
                                    <TableRow>
                                       <TableCell
                                          key={"ID"}
                                          align={"center"}
                                          style={{ minWidth: 20 }}
                                          sortDirection={orderBy === "ID" ? order : false}>
                                          {"ID"}
                                          <TableSortLabel
                                             active={orderBy === "ID"}
                                             direction={orderBy === "ID" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("ID")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"sanad_qroup"} align={"center"} style={{ minWidth: 60 }}>
                                          {"sanad_qroup"}
                                          <TableSortLabel
                                              active={orderBy === "sanad_qroup"}
                                              direction={orderBy === "sanad_qroup" ? order : "asc"}
                                              onClick={(e) => {
                                                 this.createSortHandler("sanad_qroup")
                                              }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"Shobe"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Shobe"}
                                          <TableSortLabel
                                             active={orderBy === "Shobe"}
                                             direction={orderBy === "Shobe" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Shobe")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"SalMali"} align={"center"} style={{ minWidth: 60 }}>
                                          {"SalMali"}
                                          <TableSortLabel
                                             active={orderBy === "SalMali"}
                                             direction={orderBy === "SalMali" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("SalMali")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"Code"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Code"}
                                          <TableSortLabel
                                             active={orderBy === "Code"}
                                             direction={orderBy === "Code" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Code")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"Radif"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Radif"}
                                          <TableSortLabel
                                             active={orderBy === "Radif"}
                                             direction={orderBy === "Radif" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Radif")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"Tarikh"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Tarikh"}
                                          <TableSortLabel
                                             active={orderBy === "Tarikh"}
                                             direction={orderBy === "Tarikh" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Tarikh")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"CodeKol"} align={"center"} style={{ minWidth: 60 }}>
                                          {"CodeKol"}
                                          <TableSortLabel
                                             active={orderBy === "CodeKol"}
                                             direction={orderBy === "CodeKol" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("CodeKol")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"CodeMoin"} align={"center"} style={{ minWidth: 60 }}>
                                          {"CodeMoin "}
                                          <TableSortLabel
                                             active={orderBy === "CodeMoin"}
                                             direction={orderBy === "CodeMoin" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("CodeMoin")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"CodeTaf"} align={"center"} style={{ minWidth: 60 }}>
                                          {"CodeTaf"}
                                          <TableSortLabel
                                             active={orderBy === "CodeTaf"}
                                             direction={orderBy === "CodeTaf" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("CodeTaf")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"CodeTaf2"} align={"center"} style={{ minWidth: 60 }}>
                                          {"CodeTaf2"}
                                          <TableSortLabel
                                             active={orderBy === "CodeTaf2"}
                                             direction={orderBy === "CodeTaf2" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("CodeTaf2")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"Ready"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Ready"}
                                          <TableSortLabel
                                             active={orderBy === "Ready"}
                                             direction={orderBy === "Ready" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Ready")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"CodeTaf_Group"} align={"center"} style={{ minWidth: 60 }}>
                                          {"CodeTaf_Group"}
                                          <TableSortLabel
                                             active={orderBy === "CodeTaf_Group"}
                                             direction={orderBy === "CodeTaf_Group" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("CodeTaf_Group")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"CodeTaf2_Group"} align={"center"} style={{ minWidth: 60 }}>
                                          {"CodeTaf2_Group"}
                                          <TableSortLabel
                                             active={orderBy === "CodeTaf2_Group"}
                                             direction={orderBy === "CodeTaf2_Group" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("CodeTaf2_Group")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"Sharh"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Sharh"}
                                          <TableSortLabel
                                             active={orderBy === "Sharh"}
                                             direction={orderBy === "Sharh" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Sharh")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"Bed"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Bed"}
                                          <TableSortLabel
                                             active={orderBy === "Bed"}
                                             direction={orderBy === "Bed" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Bed")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"Bes"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Bes"}
                                          <TableSortLabel
                                             active={orderBy === "Bes"}
                                             direction={orderBy === "Bes" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Bes")
                                             }}></TableSortLabel>
                                       </TableCell>
                                       <TableCell key={"ArzValue"} align={"center"} style={{ minWidth: 60 }}>
                                          {"ArzValue"}
                                          <TableSortLabel
                                             active={orderBy === "ArzValue"}
                                             direction={orderBy === "ArzValue" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("ArzValue")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"ArzFee"} align={"center"} style={{ minWidth: 60 }}>
                                          {"ArzFee"}
                                          <TableSortLabel
                                             active={orderBy === "ArzFee"}
                                             direction={orderBy === "ArzFee" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("ArzFee")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"RowDetXML"} align={"center"}>
                                          {"RowDetXML"}
                                          <TableSortLabel
                                             active={orderBy === "RowDetXML"}
                                             direction={orderBy === "RowDetXML" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("RowDetXML")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"Pages"} align={"center"} style={{ minWidth: 60 }}>
                                          {"Pages"}
                                          <TableSortLabel
                                             active={orderBy === "Pages"}
                                             direction={orderBy === "Pages" ? order : "asc"}
                                             onClick={(e) => {
                                                this.createSortHandler("Pages")
                                             }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"SqlServerResponse"} align={"center"} style={{ minWidth: 60 }}>
                                          {"SqlServerResponse"}
                                          <TableSortLabel
                                              active={orderBy === "SqlServerResponse"}
                                              direction={orderBy === "SqlServerResponse" ? order : "asc"}
                                              onClick={(e) => {
                                                 this.createSortHandler("SqlServerResponse")
                                              }}></TableSortLabel>
                                       </TableCell>

                                       <TableCell key={"sanad_head"} align={"center"} style={{ minWidth: 60 }}>
                                          {"sanad_head"}
                                          <TableSortLabel
                                              active={orderBy === "sanad_head"}
                                              direction={orderBy === "sanad_head" ? order : "asc"}
                                              onClick={(e) => {
                                                 this.createSortHandler("sanad_head")
                                              }}></TableSortLabel>
                                       </TableCell>

                                    </TableRow>
                                 </TableHead>

                                 <TableBody>
                                    {requestinfofilter.slice(0,rowsPerPage).map((row) => {
                                       return (
                                          <TableRow hover role="checkbox" tabIndex={-1} key={row["ID"]} value={row} onClick={() => {}}>
                                             <TableCell key={"ID"} align={"center"}>
                                                {row["ID"]}
                                             </TableCell>

                                             <TableCell key={"sanad_qroup"} align={"center"}>
                                                {row["sanad_qroup"]}
                                             </TableCell>

                                             <TableCell key={"Shobe"} align={"center"}>
                                                {row["Shobe"]}
                                             </TableCell>

                                             <TableCell key={"SalMali"} align={"center"}>
                                                {row["SalMali"]}
                                             </TableCell>

                                             <TableCell key={"Code"} align={"center"}>
                                                {row["Code"]}
                                             </TableCell>

                                             <TableCell key={"Radif"} align={"center"}>
                                                {row["Radif"]}
                                             </TableCell>

                                             <TableCell key={"Tarikh"} align={"center"}>
                                                {row["Tarikh"]}
                                             </TableCell>

                                             <TableCell key={"CodeKol"} align={"center"}>
                                                {row["CodeKol"]}
                                             </TableCell>

                                             <TableCell key={"CodeMoin"} align={"center"}>
                                                {row["CodeMoin"]}
                                             </TableCell>
                                             <TableCell key={"CodeTaf"} align={"center"}>
                                                {row["CodeTaf"]}
                                             </TableCell>
                                             <TableCell key={"CodeTaf2"} align={"center"}>
                                                {row["CodeTaf2"]}
                                             </TableCell>

                                             <TableCell key={"Ready"} align={"center"}>
                                                {row["Ready"]}
                                             </TableCell>

                                             <TableCell key={"CodeTaf_Group"} align={"center"}>
                                                {row["CodeTaf_Group"]}
                                             </TableCell>

                                             <TableCell key={"CodeTaf2_Group"} align={"center"}>
                                                {row["CodeTaf2_Group"]}
                                             </TableCell>
                                             <TableCell style={{ whiteSpace: "nowrap" }} key={"Sharh"} align={"center"}>
                                                {row["Sharh"]}
                                             </TableCell>
                                             <TableCell key={"Bed"} align={"center"}>
                                                {row["Bed"]}
                                             </TableCell>
                                             <TableCell key={"Bes"} align={"center"}>
                                                {row["Bes"]}
                                             </TableCell>
                                             <TableCell key={"ArzValue"} align={"center"}>
                                                {row["ArzValue"]}
                                             </TableCell>
                                             <TableCell key={"ArzFee"} align={"center"}>
                                                {row["ArzFee"]}
                                             </TableCell>
                                             <TableCell style={{ whiteSpace: "nowrap" }} key={"RowDetXML"} align={"center"}>
                                                {row["RowDetXML"]}
                                             </TableCell>
                                             <TableCell key={"Pages"} align={"center"}>
                                                {row["Pages"]}
                                             </TableCell>
                                             <TableCell key={"SqlServerResponse"} align={"center"}>
                                                {row["SqlServerResponse"]}
                                             </TableCell>
                                             <TableCell key={"sanad_head"} align={"center"}>
                                                {row["sanad_head"]}
                                             </TableCell>

                                          </TableRow>
                                       )
                                    })}
                                 </TableBody>
                              </Table>
                           </TableContainer>
                           <TablePagination
                              rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                              component="div"
                              count={arrCount}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onChangePage={this.handleChangePage}
                              onChangeRowsPerPage={this.handleChangeRowsPerPage}
                           />

                        </Paper>
                     </Container>
                  </Grid>
               </Grid>

               {okstatus ? (
                  <Alert severity="success">
                     <AlertTitle>پیام</AlertTitle>
                     {errstr}
                  </Alert>
               ) : null}
            </div>
         )
      }
   }
}

  export default withStyles(styles)(ChangeReportDocCreate)
